<script>
  import DisplayMyScheduleSerialInfo from "./DisplayMyScheduleSerialInfo.svelte";
  import DisplayWsSerialInfo from "./DisplayWsSerialInfo.svelte";

  export let license
</script>

{#if license.moduleType === "WS"}
  <DisplayWsSerialInfo license={license} />
{:else}
  <DisplayMyScheduleSerialInfo license={license} />
{/if}
